import { CalendarDays, Users, Filter, Utensils } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PremiumFeatures() {
  const { t } = useTranslation();

  const features = [
    {
      icon: (
        <CalendarDays className="w-12 h-12 text-green-600 dark:text-green-400" />
      ),
      title: t("premiumFeatures.mealPlanning.title"),
      description: t("premiumFeatures.mealPlanning.description"),
    },
    {
      icon: <Users className="w-12 h-12 text-green-600 dark:text-green-400" />,
      title: t("premiumFeatures.communityRated.title"),
      description: t("premiumFeatures.communityRated.description"),
    },
    {
      icon: <Filter className="w-12 h-12 text-green-600 dark:text-green-400" />,
      title: t("premiumFeatures.foodCategories.title"),
      description: t("premiumFeatures.foodCategories.description"),
    },
    {
      icon: (
        <Utensils className="w-12 h-12 text-green-600 dark:text-green-400" />
      ),
      title: t("premiumFeatures.nutritionalFilters.title"),
      description: t("premiumFeatures.nutritionalFilters.description"),
    },
  ];

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-12">
          {t("premiumFeatures.title")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md"
            >
              <div className="flex justify-center mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
